module.exports = __webpack_public_path__ + "static/media/videoplayer.754a8007.png";